import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from '~/services/scopedHeaders';
import { IGetPostingsParams, IPostingsApiResponse } from './types';

/** @param officeId - lists that office's postings (its `x-office`) over the selected one's */
async function getPostings(
  params: IGetPostingsParams,
  officeId?: string,
): Promise<IPostingsApiResponse> {
  const headers = await scopedHeaders(officeId);

  const response = await tempMeeApi.get<IPostingsApiResponse>(
    '/posting-service/postings',
    {
      headers,
      params: {
        page: params.page || 1,
        pageSize: params.limit || 15,
        status: params.status,
      },
    },
  );

  return response.data;
}

export const postingsApi = {
  getPostings,
};
